import type {
  MoiVendorAssignmentRuleCreateParams,
  MoiVendorAssignmentRuleInfo,
} from '~/server_shared/openapi/data-contracts';

/** The "every method" sentinel for the MOI-method multiselect. `ArrayMultiselectFieldWithChipsFormik`
 *  keeps it in the same array as the real picks, and its `useAllOptionOnMultiSelect` hook then makes
 *  All mutually exclusive with them. `id` and `value` must match: the select stores an option's `id`
 *  in that array, while the chips look the label up by `value` and the hook compares `allOption.id`
 *  against the array. */
export const ALL_MOI_METHODS_OPTION = { id: '__all__', label: 'All methods', value: '__all__' } as const;

export const isAllMoiMethodsSelected = (moiMethods: string[]): boolean =>
  moiMethods.includes(ALL_MOI_METHODS_OPTION.id);

/** `is_all` and `values` are both always set. The BE rejects `is_all` alongside a non-empty `values`,
 *  and the sentinel is a UI value, not a method key, so All is the flag alone with no values. */
export const toMoiMethodScope = (moiMethods: string[]): Required<MoiVendorAssignmentRuleCreateParams['moi_methods']> =>
  isAllMoiMethodsSelected(moiMethods) ? { is_all: true, values: [] } : { is_all: false, values: moiMethods };

/** A copy rather than the rule's own `values` array, so an in-place edit of the form value (a `push`,
 *  a `sort`) cannot change the rule object it was read from. No scope selects nothing rather than
 *  every method: All has to be an explicit pick, as the BE's create body requires `moi_methods`
 *  instead of defaulting it. */
export const fromMoiMethodScope = (scope: MoiVendorAssignmentRuleInfo['moi_methods'] | undefined): string[] =>
  scope?.is_all ? [ALL_MOI_METHODS_OPTION.id] : [...(scope?.values ?? [])];
